function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.844 23a5.156 5.156 0 100-10.312 5.156 5.156 0 000 10.312z",
  fill: "#FAC68F"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.313 3.836v4.64a2.84 2.84 0 01-2.836 2.836H3.836A2.84 2.84 0 011 8.477V3.836A2.84 2.84 0 013.836 1h4.64a2.84 2.84 0 012.836 2.836zM23 3.836v4.64a2.84 2.84 0 01-2.836 2.836h-4.64a2.84 2.84 0 01-2.836-2.835V3.836A2.84 2.84 0 0115.523 1h4.641A2.84 2.84 0 0123 3.836zM11.313 15.523v4.641A2.84 2.84 0 018.476 23H3.836A2.84 2.84 0 011 20.164v-4.64a2.84 2.84 0 012.836-2.836h4.64a2.84 2.84 0 012.836 2.835z",
  fill: "#F6C4AE"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23 17.844a5.162 5.162 0 01-5.844 5.11 5.163 5.163 0 004.469-5.11c0-2.61-1.95-4.774-4.469-5.11A5.162 5.162 0 0123 17.843z",
  fill: "#C57C5B"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.313 3.836v4.64a2.84 2.84 0 01-2.836 2.836H7.102a2.84 2.84 0 002.835-2.835V3.836A2.84 2.84 0 007.103 1h1.375a2.84 2.84 0 012.835 2.836zM23 3.836v4.64a2.84 2.84 0 01-2.836 2.836H18.79a2.84 2.84 0 002.836-2.835V3.836A2.84 2.84 0 0018.789 1h1.375A2.84 2.84 0 0123 3.836zM11.313 15.523v4.641A2.84 2.84 0 018.476 23H7.102a2.84 2.84 0 002.835-2.836v-4.64a2.84 2.84 0 00-2.835-2.836h1.375a2.84 2.84 0 012.835 2.835z",
  fill: "#F4AB8A"
});

function SvgMenuIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgMenuIcon;